// extracted by mini-css-extract-plugin
export default {"saved_filters_select_option__species_icon":"styles_saved_filters_select_option__species_icon__wBnoT","bottomMenu":"styles_bottomMenu__IAmm-","spin":"styles_spin__0gKcl"};